enum ProductSKUEnum {
  /**
   * * SAP Coupons, used to add coupon as items
   * */
  SAP_COUPON = '999000',

  SMART_HOSTING_YEARLY_STANDARD = '999813',
  SMART_HOSTING_NUKI_YEARLY_STANDARD = '999803',
  SMART_HOSTING_MONTHLY_STANDARD = '999811',
  SMART_HOSTING_NUKI_MONTHLY_STANDARD = '999802',
  SMART_LOCK_5G_ULTRA_EU = '221145',
  SMART_LOCK_5G_ULTRA_ROUND_CH = '221149',
  SMART_LOCK_5G_ULTRA_US = '221146',
  SMART_LOCK_5G_ULTRA_EU_WITHOUT_UNIVERSAL_CYLINDER = '221153',
  SMART_LOCK_5G_ULTRA_NORDICS = '221150',
  SMART_LOCK_5G_PRO_EU = '221147',
  SMART_LOCK_5G_PRO_ROUND_CH = '221151',
  SMART_LOCK_5G_GO_EU = '221148',
  SMART_LOCK_5G_GO_ROUND_CH = '221152',

  REMOTE_ACCESS_SL = '999823',
  REMOTE_ACCESS_SL_GO = '999833',
  REMOTE_ACCESS_SMART_DOOR = '220603',

  GUARANTEE_PLUS = '999800',
}

export default ProductSKUEnum;
